export default class SpecFile {}
